import React, { Component } from 'react'
// import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import './decimalinput.scss'

import { formatCurrency2, reverseFormatCurrency2 } from '../../../utils/currency'

// Components
import Text from '../../elements/text'

class DecimalInput extends Component {
  constructor (props) {
    super(props)
    this.state = {
      stringValue: formatCurrency2(props.value, this.getDecimals()),
      decimalValue: reverseFormatCurrency2(props.value)
    }

    this.onInputChange = this.onInputChange.bind(this)
    this.onBlur = this.onBlur.bind(this)
    this.getDecimals = this.getDecimals.bind(this)
    this.onKeyPress = this.onKeyPress.bind(this)
    this.transformValue = this.transformValue.bind(this)
  }

  componentDidMount () {
  }

  componentWillReceiveProps (newProps) {
    this.setState({
      stringValue: formatCurrency2(newProps.value, this.getDecimals()),
      decimalValue: reverseFormatCurrency2(newProps.value)
    })
  }

  onInputChange (e) {
    const value = this.transformValue(e.target.value, true)
    this.setState({
      stringValue: value,
      decimalValue: reverseFormatCurrency2(value)
    })
    if (this.props.onChange !== undefined) {
      this.props.onChange({
        target: {
          name: e.target.name,
          value: value
        }
      })
    }
  }

  onBlur (e, shouldAdd = false) {
    this.setState({
      stringValue: formatCurrency2(this.state.decimalValue, this.getDecimals())
    })
    if (this.props.onBlur !== undefined) {
      this.props.onBlur({
        name: this.props.name,
        value: this.state.decimalValue,
        shouldAdd
      })
    } else {
      console.error('DecimalInput is missing handler for onBlur. Inputs will not be handled.', this.props.name, this.state.decimalValue)
    }
  }

  onKeyPress (e) {
    if (e.key === 'Enter') {
      this.onBlur(e, true)
    }
  }

  getDecimals () {
    if (this.props.decimals === undefined || typeof this.props.decimals !== 'number') {
      return 2
    } else {
      return this.props.decimals
    }
  }

  transformValue (value, toClean = false) {
    if (this.props.transformValue) {
      return this.props.transformValue(value, toClean)
    }
    return value
  }

  onFocus (e) {
    let endPos = e.target.value.length
    if (e.target.value.includes('%')) {
      endPos -= 2
    }
    e.target.setSelectionRange(0, endPos)
  }

  render () {
    // let classes = this.props.className
    // if (this.props.rightAlign) {
    //   classes += ' decimal__rightAlign'
    // }

    return (
      <Text
        name={this.props.name}
        value={this.transformValue(this.state.stringValue)}
        onChange={this.onInputChange}
        onBlur={this.onBlur}
        onKeyDown={this.onKeyPress}
        onFocus={this.onFocus}
        disabled={this.props.disabled}
        labelText={this.props.labelText}
        helpText={this.props.helpText}
        size={this.props.size}
      />
    )
  }
}

DecimalInput.propTypes = {
  // auth: React.PropTypes.object.isRequired,
  name: React.PropTypes.string.isRequired
}

// DecimalInput.contextTypes = {
//   router: React.PropTypes.object.isRequired,
//   t: React.PropTypes.func.isRequired
// }

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {})(DecimalInput)



// WEBPACK FOOTER //
// ./src/app/shared/components/DecimalInput/index.js